/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_SuccessInputs */

const en_status_success = /** @type {(inputs: Status_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Success`)
};

/**
* | output |
* | --- |
* | "Success" |
*
* @param {Status_SuccessInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const status_success = /** @type {((inputs?: Status_SuccessInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_SuccessInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_status_success(inputs)
});